// NPM Imports
import React from "react";
import { useDispatch, useSelector } from "react-redux";

// Components Imports
import { ConfirmationBox } from "../../commonComponents";

// Actions imports
import { tableAPITypeChange } from "../../actions/TableFieldActions/index";

function EditTableApiHeaderPopup({
  component,
  direction,
  action,
  addTableApiRow,
  addTableApiColumn,
  removeTableApiColumn,
  checkboxLabel,
  closePopup,
  header,
  okBtnText,
  onConfirm,
  subHeader,
  componentMeta,
}) {
  // mapStateToProps
  const fieldsUsed = useSelector(
    state => state.DocumentStore.document.fields_used,
  );

  const dispatch = useDispatch();

  const _handleConfirmation = e => {
    const { clauseOptions } = component;
    const { id: dynamicFieldId } = clauseOptions;
    const clauseField = fieldsUsed.find(field => field.id === dynamicFieldId);
    const { value: tableValue, tables } = clauseField;
    const tableId = tableValue.unlinked_table_id || tableValue.linked_table_id;
    const getTable = tables[tableId];
    if (getTable && getTable.table_type !== "TABLE_DOCUMENT") {
      dispatch(
        tableAPITypeChange(
          tableId,
          clauseField,
          "TABLE_DOCUMENT",
          component.id,
        ),
      )
        .then(() => {
          if (onConfirm) {
            onConfirm(componentMeta);
          }
          if (action === "addRow") addTableApiRow(direction, e);
          if (action === "addCol") addTableApiColumn(direction, e);
          if (action === "removeCol") removeTableApiColumn(direction, e);
        })
        .catch(err => {
          console.error(
            "EditTableApiHeaderPopup => _handleConfirmation => Error",
            err,
          );
        });
    } else if (onConfirm) {
      onConfirm(componentMeta);
    }

    closePopup();
  };

  return (
    <ConfirmationBox
      show
      closePopup={closePopup}
      header={header}
      subHeader={subHeader}
      checkboxLabel={checkboxLabel}
      cancelBtnText="Cancel"
      disableCheckbox
      confirmAction={_handleConfirmation}
      okBtnText={okBtnText}
      closeOnOverlayClick={false}
    />
  );
}

export default EditTableApiHeaderPopup;
